import React from "react";
import PropTypes from "prop-types";

export default class SingleaddButton extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
  };

  render() {
    let { label, style, type, className } = this.props;

    return (
      <button
        type={type}
        className={`button-transparent button-singleadd ${className}`}
        onClick={this.props.onClick}
        title={label}
      >
        {label}
        &nbsp;
        <span className="icon-add" aria-hidden="true" />
      </button>
    );
  }
}

SingleaddButton.defaultProps = {
  label: "",
  type: "button",
  style: {},
  onClick: () => {},
};
